import "./style.scss"
import { Link } from "react-router"
import { Fade } from "react-awesome-reveal"
import { useHeadlessConsentUI } from "@c15t/react";
import Facebook from "@images/social-facebook.png"
import Instagram from "@images/social-instagram.png"
import Linkedin from "@images/social-linkedin.png"

export default function Footer () {
    const { 
        openDialog
    } = useHeadlessConsentUI();

    return (
        <footer className="footer">
            <Fade triggerOnce>
                <div className="footer-content">
                    <div>
                        <p className="footer-desc-top">Do zobaczenia!</p>
                        <p className="footer-desc-bottom">Pozostańmy <br/>w stałym kontakcie!</p>
                    </div>
                    <div className="nav-wrapper">
                        <nav>
                            <ul>
                                <li><Link to={"/"}>Home</Link></li>
                                <li><Link to={"/o-nas"}>O nas</Link></li>
                                <li><Link to={"/case-study"}>Case study</Link></li>
                                <li><Link to={"/kontakt"}>Kontakt</Link></li>
                                <li><a onClick={openDialog}>Ustawienia cookies</a></li>
                            </ul>
                        </nav>
                        <div className="contact-wrapper">
                            <div className="contact-info">
                                <p><strong>Izipizi.agency Sp. z o.o.</strong></p>
                                <p>Al. Jerozolimskie 107, Warszawa<br/>
                                    Kapitał Zakładowy: 1 000 000 zł<br/>
                                    wpłacony w całości.</p>
                            </div>
                            <nav className="contact-nav">
                                <ul>
                                    <li><a href="tel:+48509634667"><strong>tel. +48 509 634 667</strong></a></li>
                                    <li><a href="mailto:kontakt@izipizi.agency"><strong>mail: kontakt@izipizi.agency</strong></a></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </Fade>
            <div className="copyrights">
                <p>Copyright © 2026 izipizi.agency</p>
                <div className="social">
                    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><img src={Facebook} alt="" /></a>
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><img src={Instagram} alt="" /></a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><img src={Linkedin} alt="" /></a>
                </div>
            </div>
        </footer>
    )
}
